<template>
  <div style="background: #fafafa; padding: 16px">
    <vditor-preview v-if="checkHtml(content) === false" :content="content" />
    <am-editor v-else :content="content" model="view" :drag="false" />
  </div>
</template>

<script>
import { checkHtml } from '@/utils/utils';

import AmEditor from '@/components/AmEditor/index';
import VditorPreview from '@/components/VditorEditor/preview';

export default {
  components: { AmEditor, VditorPreview },
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      title: null,
      visible: false
    };
  },
  methods: {
    checkHtml
  }
};
</script>
<style>
.preview-modal .ant-modal-body {
  min-height: 50vh;
  max-height: 80vh;
  overflow: auto !important;
}
</style>
